import React, { useEffect, useState } from 'react';
import { Network } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { api } from '../lib/api';
import { usePilotContext } from '../hooks/usePilotContext';

export function AgentsPage() {
  const { context } = usePilotContext();
  const [summary, setSummary] = useState(null);
  const [paths, setPaths] = useState([]);

  useEffect(() => {
    async function load() {
      if (!context.customer_id) return;
      try {
        const [sum, p] = await Promise.all([
          api.get(`/api/registry/${context.customer_id}/summary`),
          api.get(`/api/registry/${context.customer_id}/paths?limit=50`),
        ]);
        setSummary(sum);
        setPaths(p.items || []);
      } catch (e) {
        console.error('Registry load failed:', e);
      }
    }
    load();
  }, [context.customer_id]);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-heading text-3xl font-bold text-foreground">Registry</h1>
        <p className="text-muted-foreground">Layer 2 attack path and strategy registry.</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Attack Surface Summary</CardTitle>
          <CardDescription>Aggregated strategy registry context for customer.</CardDescription>
        </CardHeader>
        <CardContent>
          <pre className="overflow-x-auto rounded-md bg-secondary/40 p-3 text-xs">{JSON.stringify(summary || {}, null, 2)}</pre>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="flex items-center gap-2"><Network className="h-4 w-4" />Attack Paths</CardTitle></CardHeader>
        <CardContent>
          <div className="space-y-2">
            {paths.length === 0 && <p className="text-sm text-muted-foreground">No paths discovered yet.</p>}
            {paths.map((p) => (
              <div key={p.path_id} className="flex items-center justify-between rounded-md border border-border p-3">
                <div>
                  <p className="font-medium">{p.attack_name || p.path_id}</p>
                  <p className="text-xs text-muted-foreground">{p.target_device || 'unknown target'} | {p.domain || 'unknown domain'}</p>
                </div>
                <Badge variant="outline">{p.attack_type || 'n/a'}</Badge>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
